import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import { User, ApiResponse } from "../types";
import {
  API_BASE_URL,
  SUPPORT_EMAIL,
  SUPPORT_PHONE,
  LIVE_URL,
} from "../utils/config";
import SuccessPopup from "./SuccessPopup";
import boutonJeMInscris from "../assets/images/bouton-je-m-inscris.png";
import playButton from "../assets/images/play.svg";
import { useLiveStatus } from "../hooks/useLiveStatus";
import { useConnectionHelpStatus } from "../hooks/useConnectionHelpStatus";

interface RegistrationFormProps {
  token: string;
  onAlert: (message: string) => void;
}

const RegistrationForm: React.FC<RegistrationFormProps> = ({
  token,
  onAlert,
}) => {
  const [formData, setFormData] = useState<User>({
    nom: "",
    prenom: "",
    email: "",
    centre: "",
    lieuExercice: "",
    rpps: "",
    civilite: "",
    type: "",
    membre: "",
    telephone: "",
  });

  const [tokenData, setTokenData] = useState(token);
  const [isValidated, setIsValidated] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);
  const [showEmailPopup, setShowEmailPopup] = useState(false);
  const [robotChecked, setRobotChecked] = useState(false);

  const isLiveActive = useLiveStatus();
  const isConnectionHelpActive = useConnectionHelpStatus();

  console.log("isConnectionHelpActive:", isConnectionHelpActive);
  const checkUserByToken = useCallback(async () => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/users/getUserByToken`,
        {
          token: token,
        }
      );

      const userData: ApiResponse = response.data;
      setFormData({
        nom: userData.prenom,
        prenom: userData.nom,
        email: userData.email,
        centre: userData.etablissement,
        lieuExercice: "",
        rpps: "",
        civilite: "",
        type: "",
        membre: "",
        telephone: "",
      });
      setIsValidated(true);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  }, [token]);

  useEffect(() => {
    checkUserByToken();
  }, [checkUserByToken]);

  const validateForm = (): boolean => {
    if (!formData.nom.trim()) {
      onAlert("Veuillez remplir le champ Nom");
      return false;
    }

    if (!formData.prenom.trim()) {
      onAlert("Veuillez remplir le champ Prénom");
      return false;
    }

    if (!formData.civilite) {
      onAlert("Veuillez cocher le champ civilite");
      return false;
    }

    if (!formData.rpps.trim()) {
      onAlert("Veuillez remplir le champ RPPS");
      return false;
    }

    if (!formData.membre) {
      onAlert("Veuillez remplir le champ Membre");
      return false;
    }

    if (formData.rpps.length < 5) {
      onAlert("Le champ RPPS doit contenir au moins 5 caractères");
      return false;
    }

    if (!formData.type) {
      onAlert("Veuillez sélectionner le champ type");
      return false;
    }

    if (
      !/^[a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ._\s-]{2,60}$/.test(
        formData.nom
      )
    ) {
      onAlert("Le champ Nom ne peut contenir que des lettres");
      return false;
    }

    if (
      !/^[a-zA-ZáàâäãåçéèêëíìîïñóòôöõúùûüýÿæœÁÀÂÄÃÅÇÉÈÊËÍÌÎÏÑÓÒÔÖÕÚÙÛÜÝŸÆŒ._\s-]{2,60}$/.test(
        formData.prenom
      )
    ) {
      onAlert("Le champ Prénom ne peut contenir que des lettres");
      return false;
    }

    if (!/^[0-9]+$/.test(formData.rpps)) {
      onAlert("Le champs RPPS ne peut contenir que des chiffres");
      return false;
    }

    if (!formData.email.trim()) {
      onAlert("Veuillez saisir une adresse mail valide");
      return false;
    }

    const lastAtPos = formData.email.lastIndexOf("@");
    const lastDotPos = formData.email.lastIndexOf(".");

    if (
      !(
        lastAtPos < lastDotPos &&
        lastAtPos > 0 &&
        formData.email.indexOf("@@") === -1 &&
        lastDotPos > 2 &&
        formData.email.length - lastDotPos > 2
      )
    ) {
      onAlert("Veuillez saisir une adresse mail valide");
      return false;
    }

    if (!formData.lieuExercice.trim()) {
      onAlert("Veuillez remplir le champ Lieu d'exercice");
      return false;
    }

    if (!formData.telephone.trim()) {
      onAlert("Veuillez remplir le champ Numéro de téléphone");
      return false;
    }

    if (!/^[0-9+\s\-()]{10,15}$/.test(formData.telephone)) {
      onAlert("Veuillez saisir un numéro de téléphone valide");
      return false;
    }

    return true;
  };

  const handleInputChange = (field: keyof User, value: string) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      const res = await axios.post(`${API_BASE_URL}/users/suscribe`, {
        nom: formData.nom,
        prenom: formData.prenom,
        email: formData.email,
        rpps: formData.rpps,
        civilite: formData.civilite,
        type: formData.type,
        membre: formData.membre,
        telephone: formData.telephone,
        lieuExercice: formData.lieuExercice,
      });


      setIsValidated(true);
      setShowSuccess(true);

      console.log(res);
      console.log(res.data);


      res.data.token && console.log("User token:", res.data.data.token);

      setTokenData(res.data.data.token);
      // redirect to same baseurl with token append at the end
      window.history.replaceState(null, "", `/${tokenData}`);

    } catch (error: any) {
      if (error.response?.status === 406) {
        onAlert("Cette adresse email est déjà enregistrée");
      } else {
        onAlert("Une erreur est survenue lors de l'inscription");
      }
    }
  };

  const handleEmailSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!robotChecked) {
      onAlert("Veuillez cocher la case «Je ne suis pas un robot» ");
      return;
    }

    try {
      const response = await axios.post(
        `${API_BASE_URL}/users/getUserByEmail`,
        {
          email_invite: formData.email,
        }
      );

      const userData = response.data;
      setFormData({
        nom: userData.prenom,
        prenom: userData.nom,
        email: userData.email,
        centre: userData.etablissement,
        lieuExercice: "",
        rpps: "",
        civilite: "",
        type: "",
        membre: "",
        telephone: "",
      });
      setIsValidated(true);
      setShowEmailPopup(false);
      setTokenData(userData.data.token.token);
    } catch (error) {
      onAlert("Adresse mail introuvable !");
    }
  };

  if (isValidated) {
    return (
      <div style={{ paddingInline: "5%", maxWidth: 500}}>
        <div className="titleInscription titleInscription2">
          <div className="title1">WEB-CONFÉRENCE</div>
        </div>

        <div className="BlueCadre">
          {isLiveActive ? (
            <div>
              <div className="PlayCadre">
                <a
                  className="linkPlay"
                  href={`https://cmho.h8live.com/${tokenData}/live1`}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={playButton} alt="" className="imgPlay" />
                </a>
              </div>
              <div className="titreTeaser">
                <p>
                  Cliquez sur le bouton play ci-dessus pour accéder au live.
                </p>
              </div>
            </div>
          ) : (
            <div className="PlayCadre">
              <div className="linkPlay2">
                <p>Patience !</p>
                <p>
                  Votre web-conférence commence le mardi 4 novembre 2025 à
                  20h00.
                </p>
              </div>
            </div>
          )}
        </div>

        <div className="bottomInscription">
          <br />
          <div className="CONTACT">
            Pour toute question, nous vous invitons à contacter l'assistance :{" "}
            <br /> Adresse email :{" "}
            <a href={`mailto:${SUPPORT_EMAIL}`} style={{ color: "#AA3F87" }}>
              {SUPPORT_EMAIL}{" "}
            </a>{" "}
            ou téléphone :{" "}
            <a href={`tel:${SUPPORT_PHONE}`} style={{ color: "#AA3F87" }}>
              {SUPPORT_PHONE}
            </a>
          </div>
        </div>

        {showSuccess && (
          <SuccessPopup
            onClose={() => setShowSuccess(false)}
            message="Votre inscription à la web-conférence « Cardiomyopathies hypertrophiques sarcomériques : l’imagerie pour optimiser la prise en charge » a bien été prise en compte et vous allez recevoir un email de confirmation."
          />
        )}
      </div>
    );
  }

  return (
    <div className="ContainerInscription" style={{ paddingInline: "5%", maxWidth: 950}}>
      <div className="FormContainer">
        <div>
          <div className="FormContainer2">
            <form onSubmit={handleSubmit}>
              <div className="titleInscription">
                <div className="title1">INSCRIPTION</div>

                <div className="memebreEcho">
                  <div className="memebreEchoLabel">
                    Je suis déjà membre echowebline{" "}
                  </div>
                  <div className="form-group">
                    <div className="form-check-inline">
                      <label className="form-check-label">
                        <input
                          type="radio"
                          className="form-check-input"
                          name="optradio2"
                          onChange={() => handleInputChange("membre", "Oui")}
                        />
                        Oui
                      </label>
                    </div>
                    <div className="form-check-inline">
                      <label className="form-check-label">
                        <input
                          type="radio"
                          className="form-check-input"
                          name="optradio2"
                          onChange={() => handleInputChange("membre", "Non")}
                        />
                        Non
                      </label>
                    </div>
                  </div>
                </div>
                <div className="title6">
                  Pour vous inscrire à la webconférence{" "}
                  <span>
                    "Cardiomyopathies hypertrophiques sarcomériques : l’imagerie
                    pour optimiser la prise en charge"
                  </span>{" "}
                  veuillez remplir le formulaire ci-dessous :
                </div>
              </div>

              <div className="form-row">
                <div className="form-column">
                  <div className="form-group">
                    <div className="form-check-inline">
                      <label className="form-check-label">
                        <input
                          type="radio"
                          className="form-check-input"
                          name="optradio"
                          onChange={() => handleInputChange("civilite", "Mme")}
                        />
                        Mme
                      </label>
                    </div>
                    <div className="form-check-inline">
                      <label className="form-check-label">
                        <input
                          type="radio"
                          className="form-check-input"
                          name="optradio"
                          onChange={() => handleInputChange("civilite", "M.")}
                        />
                        M.
                      </label>
                    </div>
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="nom"
                      placeholder="Nom*"
                      autoComplete="family-name"
                      required
                      value={formData.nom}
                      onChange={(e) => handleInputChange("nom", e.target.value)}
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="email"
                      placeholder="E-mail*"
                      autoComplete="email"
                      required
                      value={formData.email}
                      onChange={(e) =>
                        handleInputChange("email", e.target.value)
                      }
                    />
                  </div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="telephone"
                      placeholder="Numéro de téléphone*"
                      autoComplete="tel"
                      required
                      value={formData.telephone}
                      onChange={(e) =>
                        handleInputChange("telephone", e.target.value)
                      }
                    />
                  </div>
                </div>

                <div className="form-column">
                  <div className="form-group spacer"></div>
                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="prenom"
                      placeholder="Prénom*"
                      autoComplete="given-name"
                      required
                      value={formData.prenom}
                      onChange={(e) =>
                        handleInputChange("prenom", e.target.value)
                      }
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="RPPS"
                      placeholder="RPPS*"
                      autoComplete="off"
                      value={formData.rpps}
                      minLength={5}
                      onChange={(e) =>
                        handleInputChange("rpps", e.target.value)
                      }
                    />
                  </div>

                  <div className="form-group">
                    <input
                      type="text"
                      className="form-control"
                      name="lieuExercice"
                      placeholder="Lieu d'exercice (Ville, CHU, CH, …)*"
                      autoComplete="off"
                      required
                      value={formData.lieuExercice}
                      onChange={(e) =>
                        handleInputChange("lieuExercice", e.target.value)
                      }
                    />
                  </div>
                </div>
              </div>

              <div className="selectClass">
                <label>Type* : </label>
                <select
                  onChange={(e) => handleInputChange("type", e.target.value)}
                  defaultValue=""
                >
                  <option value="" disabled>
                    Choisissez ici
                  </option>
                  <option value="Cardiologie">Cardiologie</option>
                  <option value="Chirurgien">Chirurgien</option>
                  <option value="Infirmier">Infirmier</option>
                  <option value="Interne">Interne</option>
                  <option value="Industriel">Industriel</option>
                  <option value="Paramédicaux">Paramédicaux</option>
                  <option value="Autres">Autres</option>
                </select>
              </div>
              <div className="Champ">* Champs obligatoires</div>

              {isConnectionHelpActive && <div className="afterObligatoire2">
                Si vous êtes inscrit mais que vous n'avez pas reçu votre lien de
                connexion,{" "}
                <span
                  style={{
                    color: "#AA3F87",
                    fontWeight: "bold",
                    textDecoration: "underline",
                    cursor: "pointer",
                  }}
                  onClick={() => setShowEmailPopup(true)}
                >
                  cliquez ici.
                </span>
              </div> }

              <div className="CONTACT">
                Pour toute question, nous vous invitons à contacter l'assistance
                technique :<br /> Adresse email :{" "}
                <a
                  href={`mailto:${SUPPORT_EMAIL}`}
                  style={{ color: "#AA3F87" }}
                >
                  {SUPPORT_EMAIL}{" "}
                </a>{" "}
                ou téléphone :{" "}
                <a href={`tel:${SUPPORT_PHONE}`} style={{ color: "#AA3F87" }}>
                  {SUPPORT_PHONE}
                </a>
              </div>


              <div className="afterObligatoire">
                En confirmant votre inscription, vous autorisez la Filiale
                d'Imagerie Cardiovasculaire et echowebline à vous envoyer des
                communications.
              </div>

              <div className="btnValider2" onClick={handleSubmit}>
                <img src={boutonJeMInscris} alt="btn valider" />
              </div>

            </form>
          </div>
        </div>
      </div>

      {showEmailPopup && (
        <div className="containerLayer">
          <div className="containerInterieur">
            <div className="TitreInscription">
              Merci d'indiquer l'adresse e-mail avec laquelle vous vous êtes
              inscrit pour accéder au live :
            </div>

            <input
              type="email"
              name="email"
              className="inputVille"
              required
              value={formData.email}
              onChange={(e) => handleInputChange("email", e.target.value)}
              placeholder="E-mail* "
            />

            <div className="robot">
              <input
                type="radio"
                id="robot"
                name="robot"
                checked={robotChecked}
                onChange={() => setRobotChecked(true)}
              />
              <label htmlFor="robot"> Je ne suis pas un robot !</label>
            </div>

            <div className="btnValider3" onClick={handleEmailSubmit}>
              ACCÉDER AU LIVE
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default RegistrationForm;
